'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsInstanceOfRecords;

var _ = require('_');

function getIsInstanceOfRecords(maybeRecord, recordList) {
  return (0, _.some)(recordList, function (recordClass) {
    return maybeRecord instanceof recordClass;
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/utils/getIsInstanceOfRecords.js
// module id = 438
// module chunks = 0